import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('BalanceText').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    gap: '8px',
    color: theme.colors.text.primary,
    div: {
      fontWeight: 540,
      fontFamily: 'Space Grotesk',
    },
  },
}))
